import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

export const usePullQuoteStore = defineStore('pullQuote', {
  state: () => ({
    id: null,
    headline: '',
    quote: '',
    attribution: ''
  }),

  actions: {
    async fetchForStory({ storyId }) {
      this.$reset()

      return httpClient
        .get(`/api/internal/stories/${storyId}/pull_quotes`)
        .then(response => {
          const pullQuote = response.data.pull_quotes[0]

          if (pullQuote) {
            Object.assign(this, pullQuote)
          }
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    }
  }
})
